import React, { Component } from "react";
import styled from "styled-components";
import BotAvatar from "./BotAvatar";
import { getResult } from "../ChatFlow";
import { navigate } from "gatsby";

import GA from "../../src/Utils/GA";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const CompWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
`;

const BubbleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  & > .bubble {
    background-color: ${props =>
      props.bot ? "rgba(214,185,161,0.50)" : "#CCA37B"};
    border-radius: 17px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 7px 9px;
    max-width: 316px;
    margin-top: 4px;

    @media screen and (max-width: 479px) {
      max-width: 259px;
    }

    & > p {
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 1.4px;
      color: ${props => (props.bot ? "#000" : "#fff")};
    }

    & > .system-btn {
      width: 161px;
      height: 22px;
      background-color: #fff;
      margin: 3.5px 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      cursor: pointer;

      & > p {
        font-size: 13px;
        color: #b08963;
        letter-spacing: 1.3px;
      }

      & > .spinner {
        border: 3px solid lightgray;
        border-top-color: #cca37b;
        border-radius: 50%;
        width: 15px;
        height: 15px;
        animation: spin 1s linear infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }
    }
  }
`;

const delay = ms => new Promise((resolve, reject) => setTimeout(resolve, ms));

class ChattyResult extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showSpinner: false
    };
  }

  render() {
    let { answers } = this.props;
    let { showSpinner } = this.state;
    console.log("answers", answers);
    const results = [
      {
        comp: (
          <BubbleWrapper bot>
            <div className="bubble">
              <div className="system-btn" onClick={this._goToSuggestion}>
                {showSpinner ? <div className="spinner" /> : <p>查看推薦</p>}
              </div>
            </div>
          </BubbleWrapper>
        )
      }
    ];

    return (
      <Wrapper>
        {results.map((item, idx) => {
          return (
            <CompWrapper key={idx}>
              <BotAvatar isLast={idx === results.length - 1} />
              {item.comp}
            </CompWrapper>
          );
        })}
      </Wrapper>
    );
  }

  _goToSuggestion = () => {
    let { answers } = this.props;

    this.setState({ showSpinner: true });
    GA.customEvent("Click", "Chatty", "CoffeeSuggestion");
    delay(500)
      .then(() => {
        let url = getResult(answers);
        navigate(url);
      })
      .then(() => this.setState({ showSpinner: false }))
      .catch(err => console.warn(err));
  };
}

export default ChattyResult;
